import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        // School administrators list — accessible by global Admin (1) AND school owner/admin (40/41).
        if (!this.requireUserType([1, 40, 41])) return;

        if (this.isSchoolAdmin()) this.ruleForm.UserType = 41;

        // A super-admin has no implicit school, so they need the list of schools both to
        // filter the table and to say which school a new employee belongs to. Owners and
        // employees are already scoped server-side and never see the picker.
        if (!this.isSchoolAdmin()) this.GetSchoolsList();

        this.GetInfo(this.pageNo);
        this.GetAllPaymentMethods();
        this.GetAllFinancialsWithdrawing();
    },


    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        },

        totalPagesT() {
            return Math.ceil(this.pagesT / this.pageSizeT);
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            pageNoT: 1,
            pageSizeT: 10,
            pagesT: 0,
            state: 0,
            Search: '',

            // «كل المدارس» filter (super-admin only) and the schools it offers.
            FilterSchoolsId: '',
            SchoolsList: [],

            ScreenTitle: '  المستخدمين ',
            ScreenTitleSingle: '  مستخدم   ',
            ScreenTitleSingleAl: ' المستخدم  ',

            Info: [],
            InfoT: [],
            Statistics: [],

            InfoFinancialsTracker: [],

            AddDialog: false,

            SelectedItem: '',

            ruleForm: {
                Id: '',
                Name: '',
                Email: '',
                Phone: '',
                Image: '',
                ImageName: '',
                UserType: 41,
                // Sent to POST Users/Add so the new account is linked to a school in the same
                // request. A school owner leaves this empty — the server resolves their school
                // from their own identity.
                SchoolsId: '',
            },
            rules: {
                Name: this.$helper.Required(),
                UserType: this.$helper.Required(),
                Phone: this.$helper.Phone(),
                Email: this.$helper.EmailOnly(),
            },

            FinancialsruleForm: {
                Id: '',
                PaymentMethodsId: '',
                WithdrawingId: '',
                OperationOn: '',
                Value: '',
                Descriptions: '',
            },
            Financialsrules: {
                PaymentMethodsId: this.$helper.Required(),
                WithdrawingId: this.$helper.Required(),
                OperationOn: this.$helper.Required(),
                Value: this.$helper.Required(),
                Descriptions: this.$helper.Required(),
            },
        };
    },



    methods: {

        // ruleForm.SchoolsId is a form field, so "no school chosen" is the empty string —
        // but the server binds it to `long?` and System.Text.Json THROWS on "". This
        // controller has no [ApiController], so that failure arrives as a null body:
        // Add answers "خطاء في ارسال البيانات" and Edit dereferences null and 500s.
        // A school owner never sees the select at all (it is v-if'd away), so they would
        // have hit this on every single save. Send a real number or a real null.
        SchoolUserPayload() {
            const raw = this.ruleForm.SchoolsId;
            const schoolsId = (raw === '' || raw === null || raw === undefined) ? null : Number(raw);
            return Object.assign({}, this.ruleForm, { SchoolsId: schoolsId });
        },

        GetSchoolsList() {
            this.$http.GetAllSchools('')
                .then(response => { this.SchoolsList = (response.data && response.data.info) || []; })
                .catch(() => { this.SchoolsList = []; });
        },

        // Changing the school filter must return to page 1 — staying on page 3 of the
        // unfiltered list usually lands past the end of the filtered one and looks empty.
        onSchoolFilterChanged() {
            this.GetInfo(1);
        },

        SchoolNameOf(item) {
            return (item && item.schoolName) ? item.schoolName : 'غير مرتبط بمدرسة';
        },

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            // schoolStaffOnly keeps super-admins and back-office staff out of a page whose
            // whole subject is school people; FilterSchoolsId backs the «كل المدارس» filter.
            this.$http.GetUsers(this.pageNo, this.pageSize, this.Search, this.FilterSchoolsId, true)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },


        submitForm() {

            const form = document.getElementById('userForm');

            // 2. Check native Bootstrap validation
            if (!form.checkValidity()) {
                // Show validation colors
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            form.classList.remove('was-validated');
            this.ruleForm.Id = Number(0);

            // School-admin context hides the type dropdown and ClearForm nulls the
            // preset 41 — a null UserType breaks model binding server-side (the body
            // arrives null → "خطاء في ارسال البيانات"). Default it back to employee.
            if (this.ruleForm.UserType == null || this.ruleForm.UserType === '') {
                if (this.isSchoolAdmin()) this.ruleForm.UserType = 41;
            }

            const n = this.normalizePhone(this.ruleForm.Phone);
            if (!n) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'رقم الهاتف غير صالح.');
                return;
            }
            this.ruleForm.Phone = n;

            this.$blockUI.Start();
            this.$http.AddUsers(this.SchoolUserPayload())
                .then(response => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo);
                    this.ClearForm(this.ruleForm);
                    this.$helper.DestroyElemntById('CloseAdd'); // #Add modal's own dismiss button
                    // the endpoint may return {message, debugOtpCode} — show the text, not [object Object]
                    const msg = response.data && response.data.message ? response.data.message : response.data;
                    this.$helper.ShowMessage('success', 'عملية ناجحة', msg);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ', errorMsg);
                });
        },

        ViewInfo(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Email = item.email;
            this.ruleForm.UserType = item.userType;
            this.GetUsersTransactionsInfo();
            this.state = 1;
        },

        GetUsersTransactionsInfo(pageNoT) {
            this.pageNoT = pageNoT;
            if (this.pageNoT === undefined) {
                this.pageNoT = 1;
            }

            this.$blockUI.Start();

            this.$http.GetUsersTransactions(this.pageNoT, this.pageSizeT, this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.$blockUI.Stop();
                    this.InfoT = response.data.info;
                    this.pagesT = response.data.count;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.pagesT = 0;
                });
        },


        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Email = item.email;
            this.ruleForm.UserType = item.userType;

        },

        submitEditForm() {
            // 1. Reference the form element (the same ID used in your HTML)
            const form = document.getElementById('userForm');

            // 2. Smart Validation: Check native Bootstrap validity
            // And verify against your custom rules from Helper.js
            if (!form.checkValidity()) {
                // Show validation colors
                form.classList.add('was-validated');
                this.$helper.ShowMessage('warning', 'تنبيه', 'يرجى ملء الحقول المطلوبة بشكل صحيح');
                return;
            }

            // 3. Form is valid: Reset UI state and prepare data
            form.classList.remove('was-validated');
            // Convert Id to Number to match backend 'long' expectation
            this.ruleForm.Id = Number(this.ruleForm.Id);

            // 4. Call the Edit API
            this.$blockUI.Start();
            this.$http.EditUsers(this.SchoolUserPayload())
                .then(response => {
                    this.$blockUI.Stop();
                    this.GetInfo(this.pageNo); // Refresh the table
                    this.ClearForm(this.ruleForm); // Reset form data
                    this.$helper.DestroyElemntById('CloseEdit'); // #Edit modal's own dismiss button
                    this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    // Handle error messages returned by the UserController
                    let errorMsg = err.response && err.response.data ? err.response.data : 'حدث خطأ غير متوقع';
                    this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', errorMsg);
                });
        },

        // Suspended (Status=3) school users were a dead end on this page: the fork dropped
        // both the badge and this action, so once suspended they could not be restored from
        // the only page that lists them. The endpoint already existed and works.
        CancelSuspend(Id) {
            Swal.fire({
                title: 'هل أنت متأكد؟',
                text: 'سيتم إلغاء تعليق حساب هذا المستخدم',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'نعم، إلغاء التعليق',
                cancelButtonText: 'تراجع',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.CancelSuspendUser(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.GetInfo(this.pageNo);
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            const msg = err.response && err.response.data ? err.response.data : 'فشلت العملية';
                            this.$helper.ShowMessage('error', 'خطأ', msg);
                        });
                }
            });
        },

        ChangeStatus(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تغير حالة العرض  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ChangeStatusUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        ResetPassword(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية تهيئة كلمة المرور   ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.ResetPasswordUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteUsers(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },

        //Upload File
        SelectImage(file) {

            // Check if file is defined
            if (!file) {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'يرجى اختيار ملف');
                return;
            }

            let str = file.type; // Access type property safely
            str = str.substring(0, 5);

            // Check if the file type is an image
            if (str !== "image") {
                this.$helper.ShowMessage('error', 'خطأ بالعملية', 'الرجاء التأكد من نوع الملف');
                return;
            }

            var $this = this;
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                $this.ruleForm.ImageName = file.name;
                $this.ruleForm.Image = reader.result;
            };
        },






        //Financials
        OpenFinancials(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Email = item.email;
            this.ruleForm.UserType = item.userType;
        },

        submitFinancialsruleForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.FinancialsruleForm.Id = this.SelectedItem.id;
                    this.FinancialsruleForm.Value = Number(this.FinancialsruleForm.Value);
                    this.$blockUI.Start();
                    this.$http.PayUsersFinancials(this.FinancialsruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo(this.pageNo);
                            this.GetFinancialsTracker();
                            this.ClearForm(this.FinancialsruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        OpenFinancialsTracker(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.Name = item.name;
            this.ruleForm.Phone = item.phone;
            this.ruleForm.Email = item.email;
            this.ruleForm.UserType = item.userType;
            this.GetFinancialsTracker();

        },

        GetFinancialsTracker() {
            this.$blockUI.Start();
            this.$http.GetUsersFinancials(this.SelectedItem.id)
                .then(response => {
                    this.$blockUI.Stop();
                    this.InfoFinancialsTracker = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },

        DeleteFinancials(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeleteUsersFinancials(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo(this.pageNo);
                            this.GetFinancialsTracker();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطأ بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },





        Back() {
            this.SelectedItem = '';
            this.state = 0;
            this.GetInfo(this.pageNo);
        },

        onPageSizeChanged(size) {
            this.pageSize = size;
            this.pageNo = 1;
            this.GetInfo();
        },

    }
}
